import APIService from '../api.service';

const ExpenseService = {
    List: async (params) => {
        const query = {
            per_page: params.perPage,
            page: params.page,
            keyword: params.keyword || undefined,
            from_date: params.from_date || undefined,
            to_date: params.to_date || undefined,
            status: params.status || undefined,
            warehouse_id: params.warehouse_id || undefined,
        };

        if (params.expense_subheader_id !== undefined && params.expense_subheader_id !== null && params.expense_subheader_id !== '') {
            query.expense_subheader_id = params.expense_subheader_id;
        }

        return APIService.get('/v01/expenses', { params: query });
    },
    Create: async (body, config = {}) => {
        return APIService.post('/v01/expenses', body, config);
    },
    Put: async (id, body, config = {}) => {
        // If it's a multipart request (with file), we need to use POST with _method=PUT
        if (body instanceof FormData) {
            body.append('_method', 'PUT');
            return APIService.post(`/v01/expenses/${id}`, body, config);
        }
        return APIService.put(`/v01/expenses/${id}`, body, config);
    },
    Delete: async (id, config = {}) => {
        return APIService.delete(`/v01/expenses/${id}`, config);
    },
    ChangeStatus: async (id, status) => {
        return APIService.put(`/v01/expenses/${id}/status`, { status });
    },
    GetCategories: async () => {
        return APIService.get('/v01/expenses/categories');
    },
    // Header Methods
    GetHeaders: async () => {
        return APIService.get('/v01/expense-headers');
    },
    CreateHeader: async (data) => {
        return APIService.post('/v01/expense-headers', data);
    },
    UpdateHeader: async (id, data) => {
        return APIService.put(`/v01/expense-headers/${id}`, data);
    },
    DeleteHeader: async (id) => {
        return APIService.delete(`/v01/expense-headers/${id}`);
    },
    // Subheader Methods
    GetSubheaders: async () => {
        return APIService.get('/v01/expense-subheaders');
    },
    CreateSubheader: async (data) => {
        return APIService.post('/v01/expense-subheaders', data);
    },
    UpdateSubheader: async (id, data) => {
        return APIService.put(`/v01/expense-subheaders/${id}`, data);
    },
    DeleteSubheader: async (id) => {
        return APIService.delete(`/v01/expense-subheaders/${id}`);
    },
};

export default ExpenseService;
